import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import TextField from "@mui/material/TextField";
import i18n from "../../../../constants/i18n";
import { withLiteObserverAndTheme } from "../../../../core/et3-enhanced-render";
import getCorePersonalStore from "../../../../stores/core/core-personal-store";

const KhattabatPasswordForm = withLiteObserverAndTheme(() => {
  const {
    oldPassword,
    newPassword,
    confirmPassword,
    setOldPassword,
    setNewPassword,
    setConfirmPassword,
    getIsChangePasswordEnabled,
    changePasswordHandler
  } = getCorePersonalStore();

  return (
    <Stack spacing={2}>
      <TextField
        label={i18n.get("OLD_PASSWORD")}
        type="password"
        autoComplete="current-password"
        fullWidth
        value={oldPassword.get()}
        onChange={(event) => setOldPassword(event.target.value)}
      />
      <TextField
        label={i18n.get("NEW_PASSWORD")}
        type="password"
        autoComplete="new-password"
        fullWidth
        value={newPassword.get()}
        onChange={(event) => setNewPassword(event.target.value)}
      />
      <TextField
        label={i18n.get("CONFIRM_PASSWORD")}
        type="password"
        autoComplete="new-password"
        fullWidth
        value={confirmPassword.get()}
        onChange={(event) => setConfirmPassword(event.target.value)}
      />
      <Button
        variant="contained"
        size="large"
        fullWidth
        disabled={!getIsChangePasswordEnabled()}
        onClick={() => changePasswordHandler()}
      >
        {i18n.get("CHANGE_PASSWORD")}
      </Button>
    </Stack>
  );
});
export default KhattabatPasswordForm;
